import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import '../ManageUsers/ManageUser.scss';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import './ManageOrders.scss';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import GridDateFormatter from '../../../GridDateFormatter';
import axios from 'axios';
import { OrdersLoader } from './OrdersLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import Modal from 'react-modal';
import DialogContainer from './Dialogs/DialogContainer';

const FileDownload = require('js-file-download');

export default class ManageOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            orderInEdit: {},
            isPopupVisible: false,
            orders: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "OrderDate", dir: "desc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {

        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && filters[i].field == "OrderDate") {
                    var operator = filters[i].operator;

                    if ((operator == "gt" || operator == "gte") && !filters[i].value) {

                        filters[i].value = new Date('January 01, 1900');

                    } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

                        var currentDatetime = new Date();

                        filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

                    }
                } else if (filters[i].field && (filters[i].field == "TransactionId" || filters[i].field == "MembershipId")) {
                    var operator = filters[i].operator;

                    if (!filters[i].value && (operator == "lt" || operator == "lte" || operator == "gt" || operator == "gte")) {

                        filters[i].value = 0;

                    }

                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (ordersFetched) => {
        this.setState({
            ...this.state,
            orders: ordersFetched,
            isLoading: false
        });

        if (ordersFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (ordersFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            orderInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    updateOrder = (dataItem) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: []
                },
                sort: [{ field: "OrderDate", dir: "desc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageOrder/UpdateOrder`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to update the order.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });    
    }

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i]};
                if (element["field"] == "OrderDate") {
                    let date = element.value;
                    if (!date) {
                        date = "01/01/0001";
                    }
                    else {
                        date = (date + '').split(" ");
                        let day = date[2] + '';
                        let year = date[3] + '';
                        let month = "01";
                        switch (date[1]) {
                            case "Jan":
                                month = "01";
                                break;
                            case "Feb":
                                month = "02";
                                break;
                            case "Mar":
                                month = "03";
                                break;
                            case "Apr":
                                month = "04";
                                break;
                            case "May":
                                month = "05";
                                break;
                            case "Jun":
                                month = "06";
                                break;
                            case "Jul":
                                month = "07";
                                break;
                            case "Aug":
                                month = "08";
                                break;
                            case "Sep":
                                month = "09";
                                break;
                            case "Oct":
                                month = "10";
                                break;
                            case "Nov":
                                month = "11";
                                break;
                            case "Dec":
                                month = "12";
                                break;
                        }
                        date = month + "/" + day + "/" + year;
                        element["value"] = date;
                    }
                }
                else {
                    for (var key in t[i]) {
                        element[key] = element[key] + '';
                    }
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageOrder/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Orders.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"orders-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading orders" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.orders.total}
                                {...this.state.dataState}
                                {...this.state.orders}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageOrders/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="OrderNumber" title="Order #" filter="text" />
                                {/*<Column field="TransactionId" title="Transaction Id" filter="numeric" />*/}
                                <Column field="MembershipId" title="Membership Id" filter="numeric" />
                                <Column field="OrderDate" title="Order Date" filter="date" cell={GridDateFormatter}/>
                                <Column field="Address" title="Order Address" filter="text" />
                                <Column field="GrandTotal" title="Order Total" filter="numeric" format="{0:c2}" />
                                <Column field="OrderName" title="Order Name" filter="text" />
                                <Column field="OrderStatus" title="Order Status" filter="text" />
                                <Column field="MembershipNumber" title="Membership Number" filter="text" />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <OrdersLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <Modal
                                isOpen={Boolean(this.state.orderInEdit)}
                                onRequestClose={this.cancel}
                                contentLabel="Example Modal"
                                ariaHideApp={false}
                                style={{
                                    content: {
                                        top: '50%',
                                        left: '50%',
                                        right: 'auto',
                                        bottom: 'auto',
                                        marginRight: '-50%',
                                        minWidth: '80vw',
                                        maxWidth: '80vw',
                                        minHeight: '80vh',
                                        maxHeight: '80vh',
                                        overflow: 'auto',
                                        transform: 'translate(-50%, -50%)',
                                        borderRadius: '5px'
                                    }
                                }}
                            >
                                <DialogContainer
                                    dialogType="edit"
                                    dataItem={this.state.orderInEdit}
                                    cancel={this.cancel}
                                    updateOrder={this.updateOrder}
                                />
                            </Modal>
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

